// Generated by scripts/sync-theme-assets.mjs from assets/restock-toggle-service.js.
// Do not edit this file directly.

(() => {
  'use strict';

  if (window.MMRestockToggleService) return;

  const SUBSCRIBED_CLASS = 'mm-restock-cta__button--subscribed';
  const RINGING_CLASS = 'restock-bell--ringing';
  const SUBSCRIPTION_CHANGE_EVENT = 'mrmaple:restock-subscription-changed';
  const RESTOCK_TRACE_ID_HEADER = 'x-mm-restock-trace-id';
  const RESTOCK_TRACE_SOURCE_HEADER = 'x-mm-restock-source';
  const RESTOCK_TRACE_SURFACE_HEADER = 'x-mm-restock-surface';
  const RESTOCK_TRACE_COMPONENT_HEADER = 'x-mm-restock-component';
  const PERSISTED_SUBSCRIPTION_HINTS_STORAGE_KEY = 'mm_restock_subscribed_keys_v1';
  const MIN_PENDING_MS = 180;
  const DIRECT_TOGGLE_DEBOUNCE_MS = 400;
  const HINT_FRESH_MS = 30000;
  const RESTOCK_OPTIMISTIC_PREFIX = 'restock:';
  const controllers = new Set();
  const toastState = { timer: null };
  const sourcePopoverState = { root: null, anchor: null, cleanup: null };
  const scheduledToastState = new Map();
  const SCHEDULED_TOAST_RAPID_WINDOW_MS = 600;
  const SCHEDULED_TOAST_DEBOUNCE_MS = 280;

  let subscribedKeys = null;
  let subscriptionStateByKey = null;
  let hydrationPromise = null;
  let hydrationScheduled = false;
  let hydrationApiBase = null;
  let hydrationCoverage;
  let sourcePopoverStyleMounted = false;
  const statusBootstrapSources = new Map();
  const statusBootstrapProductGids = new Set();
  const localSubscriptionOverrides = new Map();
  const mutationStateByKey = new Map();
  let persistedSubscriptionHintsCache = null;

  function normalizeApiBase(apiBase) {
    return String(apiBase || '/apps/garden').replace(/\/$/, '');
  }

  function normalizeVariantId(value) {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
  }

  function isPersistedSubscriptionId(value) {
    if (typeof value !== 'string') return false;
    const trimmed = value.trim();
    return (
      Boolean(trimmed) &&
      !trimmed.includes('/') &&
      !trimmed.startsWith('local-direct::') &&
      !trimmed.startsWith('preview-direct::')
    );
  }

  function buildSubscriptionKey(productGid, variantId) {
    return `${productGid}::${variantId || 'all-variants'}`;
  }

  function buildOptimisticPersistenceKey(productGid, variantId) {
    return `${RESTOCK_OPTIMISTIC_PREFIX}${buildSubscriptionKey(productGid, variantId)}`;
  }

  function parseOptimisticPersistenceKey(key) {
    const normalizedKey = String(key || '');
    if (!normalizedKey.startsWith(RESTOCK_OPTIMISTIC_PREFIX)) {
      return null;
    }

    const raw = normalizedKey.slice(RESTOCK_OPTIMISTIC_PREFIX.length);
    const separatorIndex = raw.lastIndexOf('::');
    if (separatorIndex === -1) {
      return null;
    }

    const productGid = raw.slice(0, separatorIndex);
    const variantToken = raw.slice(separatorIndex + 2);
    if (!productGid) {
      return null;
    }

    return {
      productGid,
      variantId:
        variantToken && variantToken !== 'all-variants'
          ? normalizeVariantId(variantToken)
          : null,
    };
  }

  function getPersistedDirectSubscriptionIntent(productGid, variantId) {
    if (!productGid) return null;

    const optimistic = window.MrMapleOptimistic;
    if (!optimistic || typeof optimistic.getPersistedToggleIntent !== 'function') {
      return null;
    }

    return (
      optimistic.getPersistedToggleIntent(
        buildOptimisticPersistenceKey(productGid, variantId),
      ) ||
      optimistic.getPersistedToggleIntent(
        buildOptimisticPersistenceKey(productGid, null),
      ) ||
      null
    );
  }

  function canUseLocalStorage() {
    try {
      return Boolean(window.localStorage);
    } catch (_) {
      return false;
    }
  }

  function loadPersistedSubscriptionHints() {
    if (persistedSubscriptionHintsCache && typeof persistedSubscriptionHintsCache === 'object') {
      return persistedSubscriptionHintsCache;
    }

    persistedSubscriptionHintsCache = {};

    if (!canUseLocalStorage()) {
      return persistedSubscriptionHintsCache;
    }

    try {
      const raw = window.localStorage.getItem(PERSISTED_SUBSCRIPTION_HINTS_STORAGE_KEY);
      if (!raw) {
        return persistedSubscriptionHintsCache;
      }

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return persistedSubscriptionHintsCache;
      }

      Object.keys(parsed).forEach((key) => {
        if (parsed[key]) {
          persistedSubscriptionHintsCache[key] =
            typeof parsed[key] === 'number' ? parsed[key] : true;
        }
      });
    } catch (_) {}

    return persistedSubscriptionHintsCache;
  }

  function persistSubscriptionHints(nextHints) {
    persistedSubscriptionHintsCache = nextHints && typeof nextHints === 'object' ? nextHints : {};

    if (!canUseLocalStorage()) {
      return persistedSubscriptionHintsCache;
    }

    try {
      const keys = Object.keys(persistedSubscriptionHintsCache);
      if (!keys.length) {
        window.localStorage.removeItem(PERSISTED_SUBSCRIPTION_HINTS_STORAGE_KEY);
      } else {
        window.localStorage.setItem(
          PERSISTED_SUBSCRIPTION_HINTS_STORAGE_KEY,
          JSON.stringify(persistedSubscriptionHintsCache),
        );
      }
    } catch (_) {}

    return persistedSubscriptionHintsCache;
  }

  function writePersistedSubscriptionHint(productGid, variantId, subscribed) {
    if (!productGid) return false;

    const key = buildSubscriptionKey(productGid, normalizeVariantId(variantId));
    const nextHints = { ...loadPersistedSubscriptionHints() };

    if (subscribed) {
      nextHints[key] = Date.now();
    } else {
      delete nextHints[key];
    }

    persistSubscriptionHints(nextHints);
    return Boolean(nextHints[key]);
  }

  function readPersistedSubscriptionHint(productGid, variantId) {
    if (!productGid) return false;

    const normalizedVariantId = normalizeVariantId(variantId);
    const hints = loadPersistedSubscriptionHints();
    const exactKey = buildSubscriptionKey(productGid, normalizedVariantId);
    const fallbackKey = buildSubscriptionKey(productGid, null);

    return Boolean(hints[exactKey] || (fallbackKey !== exactKey && hints[fallbackKey]));
  }

  function syncPersistedSubscriptionHintsFromState(target) {
    if (!(target instanceof Map)) return persistSubscriptionHints({});

    const now = Date.now();
    const currentHints = loadPersistedSubscriptionHints();
    const nextHints = {};

    target.forEach((bucket, key) => {
      if (Array.isArray(bucket?.sources) && bucket.sources.length > 0) {
        nextHints[key] = currentHints[key] || now;
      }
    });

    Object.keys(currentHints).forEach((key) => {
      if (nextHints[key]) return;
      const ts = currentHints[key];
      const isFresh = typeof ts === 'number' && (now - ts) < HINT_FRESH_MS;
      const record = mutationStateByKey.get(key);
      const hasPendingMutation =
        record && record.desiredDirectSubscribed !== record.committedDirectSubscribed;
      if (isFresh || hasPendingMutation) {
        nextHints[key] = ts;
      }
    });

    return persistSubscriptionHints(nextHints);
  }

  function resolveValue(value, controller) {
    return typeof value === 'function' ? value(controller) : value;
  }

  function normalizeTraceToken(value, maxLength = 120) {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed ? trimmed.slice(0, maxLength) : null;
  }

  function generateTraceId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return `restock-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function createClientTraceContext(options = {}) {
    return {
      traceId:
        normalizeTraceToken(resolveValue(options.traceId, null), 160) || generateTraceId(),
      source:
        normalizeTraceToken(resolveValue(options.requestSource, null)) ||
        normalizeTraceToken(resolveValue(options.source, null)) ||
        'restock-toggle-service',
      surface: normalizeTraceToken(resolveValue(options.traceSurface, null)),
      component: normalizeTraceToken(resolveValue(options.traceComponent, null)),
    };
  }

  function logClientTrace(trace, event, detail = {}) {
    if (!trace?.traceId) return;

    console.log(`[RestockToggle:TRACE] trace=${trace.traceId} event=${event}`, {
      source: trace.source || null,
      surface: trace.surface || null,
      component: trace.component || null,
      ...detail,
    });
  }

  function extractGroups(data) {
    return data?.subscriptions || data?.items || data || [];
  }

  function createSubscriptionStateCache() {
    if (!(subscriptionStateByKey instanceof Map)) {
      subscriptionStateByKey = new Map();
    }

    return subscriptionStateByKey;
  }

  function cloneSource(source) {
    return {
      subscriptionId:
        typeof source?.subscriptionId === 'string' && source.subscriptionId.trim()
          ? source.subscriptionId.trim()
          : null,
      productGid:
        typeof source?.productGid === 'string' && source.productGid.trim()
          ? source.productGid.trim()
          : '',
      variantId: normalizeVariantId(source?.variantId || null),
      sourceType: source?.sourceType === 'list' ? 'list' : 'direct',
      wishlistId:
        typeof source?.wishlistId === 'string' && source.wishlistId.trim()
          ? source.wishlistId.trim()
          : null,
      wishlistName:
        typeof source?.wishlistName === 'string' && source.wishlistName.trim()
          ? source.wishlistName.trim()
          : null,
      label:
        typeof source?.label === 'string' && source.label.trim()
          ? source.label.trim()
          : null,
      optimistic: source?.optimistic === true,
    };
  }

  function createSourceFingerprint(source) {
    if (source?.subscriptionId) {
      return `id:${source.subscriptionId}`;
    }

    return [
      source?.productGid || '',
      source?.variantId || 'all-variants',
      source?.sourceType || 'direct',
      source?.wishlistId || 'direct',
      source?.wishlistName || '',
    ].join('::');
  }

  function getSourceVariantId(source) {
    return normalizeVariantId(source?.variantId || null);
  }

  function sourceLabel(source) {
    if (!source) return 'Alert';
    if (typeof source.label === 'string' && source.label.trim()) {
      return source.label.trim();
    }
    if (source.sourceType === 'list') {
      return source.wishlistName || 'List alert';
    }
    return 'Direct alert';
  }

  function createSourceRecord(entry, groupMeta = {}) {
    const productGid = entry?.productGid || entry?.product_gid || groupMeta.productGid || '';
    if (typeof productGid !== 'string' || !productGid.trim()) {
      return null;
    }

    const wishlistId =
      entry?.wishlistId ??
      entry?.wishlist_id ??
      groupMeta.wishlistId ??
      null;
    const wishlistName =
      entry?.wishlistName ??
      groupMeta.wishlistName ??
      null;
    const explicitType =
      typeof entry?.sourceType === 'string' && entry.sourceType.trim()
        ? entry.sourceType.trim().toLowerCase()
        : '';

    return cloneSource({
      subscriptionId:
        entry?.subscriptionId ||
        entry?.id ||
        null,
      productGid: productGid.trim(),
      variantId: entry?.variantId || entry?.variant_id || groupMeta.variantId || null,
      sourceType:
        explicitType === 'list' || wishlistId
          ? 'list'
          : 'direct',
      wishlistId,
      wishlistName:
        typeof wishlistName === 'string' && wishlistName.trim()
          ? wishlistName.trim()
          : null,
      label:
        explicitType === 'direct'
          ? 'Direct alert'
          : typeof entry?.label === 'string' && entry.label.trim()
            ? entry.label.trim()
            : null,
    });
  }

  function upsertSourceRecord(target, source) {
    if (!(target instanceof Map) || !source?.productGid) return;

    const key = buildSubscriptionKey(source.productGid, source.variantId);
    const bucket = target.get(key) || { sources: [] };
    const fingerprint = createSourceFingerprint(source);
    const nextSources = bucket.sources.filter(
      (existing) => createSourceFingerprint(existing) !== fingerprint,
    );
    nextSources.push(cloneSource(source));
    target.set(key, { sources: nextSources });
  }

  function applyDirectOverride(target, key, directSubscribed) {
    const [productGid, variantToken] = String(key || '').split('::');
    if (!productGid) return;

    const variantId = variantToken === 'all-variants' ? null : normalizeVariantId(variantToken);
    const bucket = target.get(key) || { sources: [] };
    const nextSources = bucket.sources.filter((source) => source?.sourceType !== 'direct');

    if (directSubscribed) {
      nextSources.push(
        cloneSource({
          subscriptionId: `local-direct::${key}`,
          productGid,
          variantId,
          sourceType: 'direct',
          label: 'Direct alert',
          optimistic: true,
        }),
      );
    }

    if (nextSources.length > 0) {
      target.set(key, { sources: nextSources });
    } else {
      target.delete(key);
    }
  }

  function recordSubscriptionOverride(productGid, variantId, directSubscribed) {
    if (!productGid) return;
    localSubscriptionOverrides.set(
      buildSubscriptionKey(productGid, variantId),
      Boolean(directSubscribed),
    );
  }

  function refreshSubscribedKeysFromState(target) {
    subscribedKeys = new Set();
    if (!(target instanceof Map)) {
      return subscribedKeys;
    }

    target.forEach((bucket, key) => {
      if (Array.isArray(bucket?.sources) && bucket.sources.length > 0) {
        subscribedKeys.add(key);
      }
    });

    return subscribedKeys;
  }

  function applySubscriptionOverrides(target) {
    if (!(target instanceof Map) || localSubscriptionOverrides.size === 0) {
      return target;
    }

    localSubscriptionOverrides.forEach((directSubscribed, key) => {
      applyDirectOverride(target, key, directSubscribed);
    });

    return target;
  }

  function fillSubscriptionCache(data, options = {}) {
    const nextState = new Map();
    if (options.clearOverrides === true) {
      localSubscriptionOverrides.clear();
    }

    const groups = extractGroups(data);
    if (!Array.isArray(groups)) {
      subscriptionStateByKey = applySubscriptionOverrides(nextState);
      syncPersistedSubscriptionHintsFromState(subscriptionStateByKey);
      refreshSubscribedKeysFromState(subscriptionStateByKey);
      return subscribedKeys;
    }

    groups.forEach((entry) => {
      if (Array.isArray(entry?.sources)) {
        entry.sources.forEach((source) => {
          const record = createSourceRecord(source, {
            productGid: entry?.productGid || entry?.id || '',
            variantId: entry?.variantId || null,
          });
          if (record) {
            upsertSourceRecord(nextState, record);
          }
        });
      }

      const nested = entry?.subscriptions;
      if (Array.isArray(nested)) {
        nested.forEach((subscription) => {
          const record = createSourceRecord(subscription, {
            wishlistId: entry?.wishlistId ?? entry?.wishlist_id ?? null,
            wishlistName: entry?.wishlistName ?? null,
          });
          if (record) {
            upsertSourceRecord(nextState, record);
          }
        });
        return;
      }

      const record = createSourceRecord(entry);
      if (record) {
        upsertSourceRecord(nextState, record);
      }
    });

    subscriptionStateByKey = applySubscriptionOverrides(nextState);
    syncPersistedSubscriptionHintsFromState(subscriptionStateByKey);
    refreshSubscribedKeysFromState(subscriptionStateByKey);
    return subscribedKeys;
  }

  function getMergedSources(productGid, variantId) {
    if (!(subscriptionStateByKey instanceof Map) || !productGid) {
      return [];
    }

    const exactKey = buildSubscriptionKey(productGid, variantId);
    const fallbackKey = buildSubscriptionKey(productGid, null);
    const fingerprints = new Set();
    const merged = [];
    const buckets = [subscriptionStateByKey.get(exactKey)];

    if (fallbackKey !== exactKey) {
      buckets.push(subscriptionStateByKey.get(fallbackKey));
    }

    buckets.forEach((bucket) => {
      if (!Array.isArray(bucket?.sources)) return;
      bucket.sources.forEach((source) => {
        const fingerprint = createSourceFingerprint(source);
        if (fingerprints.has(fingerprint)) return;
        fingerprints.add(fingerprint);
        merged.push(cloneSource(source));
      });
    });

    return merged;
  }

  function getProductSubscriptionState(productGid, variantId, options = {}) {
    const normalizedVariantId = normalizeVariantId(variantId);
    let sources = getMergedSources(productGid, normalizedVariantId);
    const includePersistedIntent = options.includePersistedIntent !== false;
    const persistedIntent = includePersistedIntent
      ? getPersistedDirectSubscriptionIntent(productGid, normalizedVariantId)
      : null;

    if (includePersistedIntent && persistedIntent && typeof persistedIntent.value === 'boolean') {
      sources = sources.filter((source) => source?.sourceType !== 'direct');
      if (persistedIntent.value) {
        sources.push(
          cloneSource({
            subscriptionId: `preview-direct::${buildSubscriptionKey(productGid, normalizedVariantId)}`,
            productGid,
            variantId: normalizedVariantId,
            sourceType: 'direct',
            label: 'Direct alert',
            optimistic: true,
          }),
        );
      }
    }

    if (
      sources.length === 0 &&
      readPersistedSubscriptionHint(productGid, normalizedVariantId)
    ) {
      sources = [
        cloneSource({
          subscriptionId: `preview-direct::${buildSubscriptionKey(productGid, normalizedVariantId)}`,
          productGid,
          variantId: normalizedVariantId,
          sourceType: 'direct',
          label: 'Direct alert',
          optimistic: true,
        }),
      ];
    }

    if (typeof options.directOverride === 'boolean') {
      sources = sources.filter((source) => source?.sourceType !== 'direct');
      if (options.directOverride) {
        sources.push(
          cloneSource({
            subscriptionId: `preview-direct::${buildSubscriptionKey(productGid, normalizedVariantId)}`,
            productGid,
            variantId: normalizedVariantId,
            sourceType: 'direct',
            label: 'Direct alert',
            optimistic: true,
          }),
        );
      }
    }

    const directSources = sources.filter((source) => source?.sourceType === 'direct');
    const indirectSources = sources.filter((source) => source?.sourceType !== 'direct');
    const labels = sources.map((source) => sourceLabel(source));

    return {
      productGid: productGid || '',
      variantId: normalizedVariantId,
      aggregateSubscribed: sources.length > 0,
      directSubscribed: directSources.length > 0,
      hasIndirectSources: indirectSources.length > 0,
      directSources,
      indirectSources,
      sources,
      labels,
    };
  }

  function createMutationRecord(productGid, variantId, directSubscribed = false) {
    return {
      key: buildSubscriptionKey(productGid, variantId),
      productGid,
      variantId: normalizeVariantId(variantId),
      desiredDirectSubscribed: Boolean(directSubscribed),
      committedDirectSubscribed: Boolean(directSubscribed),
      syncPromise: null,
      sourceActionPromise: null,
    };
  }

  function getProductMutationState(productGid, variantId, initialDirectSubscribed = false) {
    if (!productGid) {
      return createMutationRecord('', variantId, initialDirectSubscribed);
    }

    const key = buildSubscriptionKey(productGid, variantId);
    const existing = mutationStateByKey.get(key);
    if (existing) {
      return existing;
    }

    const subscriptionState = getProductSubscriptionState(productGid, variantId, {
      includePersistedIntent: false,
    });
    const record = createMutationRecord(
      productGid,
      variantId,
      subscriptionState.directSubscribed || initialDirectSubscribed,
    );
    mutationStateByKey.set(key, record);
    return record;
  }

  function getCachedSubscription(productGid, variantId) {
    return getProductSubscriptionState(productGid, variantId).aggregateSubscribed;
  }

  function setCachedDirectSubscription(productGid, variantId, subscribed, payload = null) {
    if (!productGid) return;
    const target = createSubscriptionStateCache();
    const key = buildSubscriptionKey(productGid, variantId);
    const bucket = target.get(key) || { sources: [] };
    const nextSources = bucket.sources.filter((source) => source?.sourceType !== 'direct');

    recordSubscriptionOverride(productGid, variantId, subscribed);
    if (subscribed) {
      nextSources.push(
        cloneSource({
          subscriptionId:
            typeof payload?.subscriptionId === 'string' && payload.subscriptionId.trim()
              ? payload.subscriptionId.trim()
              : `local-direct::${key}`,
          productGid,
          variantId,
          sourceType: 'direct',
          label: 'Direct alert',
        }),
      );
    }

    if (nextSources.length > 0) {
      target.set(key, { sources: nextSources });
    } else {
      target.delete(key);
    }

    refreshSubscribedKeysFromState(target);
    writePersistedSubscriptionHint(productGid, variantId, subscribed);
  }

  function removeCachedSource(productGid, variantId, matcher) {
    if (!productGid || !(subscriptionStateByKey instanceof Map)) return;

    const key = buildSubscriptionKey(productGid, variantId);
    const bucket = subscriptionStateByKey.get(key);
    if (!Array.isArray(bucket?.sources)) return;

    const nextSources = bucket.sources.filter((source) => !matcher(source));
    if (nextSources.length > 0) {
      subscriptionStateByKey.set(key, { sources: nextSources });
    } else {
      subscriptionStateByKey.delete(key);
    }

    refreshSubscribedKeysFromState(subscriptionStateByKey);
    writePersistedSubscriptionHint(
      productGid,
      variantId,
      getProductSubscriptionState(productGid, variantId).aggregateSubscribed,
    );
  }

  function removeCachedSourcesForProduct(productGid, variantId) {
    if (!(subscriptionStateByKey instanceof Map) || !productGid) return;

    const keys = new Set([
      buildSubscriptionKey(productGid, variantId),
      buildSubscriptionKey(productGid, null),
    ]);

    keys.forEach((key) => subscriptionStateByKey.delete(key));
    refreshSubscribedKeysFromState(subscriptionStateByKey);
    writePersistedSubscriptionHint(productGid, variantId, false);
    writePersistedSubscriptionHint(productGid, null, false);
  }

  function replaceCachedSourcesForProduct(productGid, variantId, sources = []) {
    if (!productGid) return;

    const normalizedVariantId = normalizeVariantId(variantId);
    const nextSources = Array.isArray(sources) ? sources.map(cloneSource) : [];

    removeCachedSourcesForProduct(productGid, normalizedVariantId);
    recordSubscriptionOverride(productGid, normalizedVariantId, false);
    recordSubscriptionOverride(productGid, null, false);

    if (!nextSources.length) {
      return;
    }

    const target = createSubscriptionStateCache();
    let directSubscribedForVariant = false;
    let directSubscribedForFallback = false;

    nextSources.forEach((source) => {
      upsertSourceRecord(target, source);

      if (source?.sourceType !== 'direct') {
        return;
      }

      const sourceVariantId = normalizeVariantId(source.variantId);
      if (sourceVariantId === normalizedVariantId) {
        directSubscribedForVariant = true;
      }

      if (sourceVariantId === null) {
        directSubscribedForFallback = true;
      }
    });

    recordSubscriptionOverride(productGid, normalizedVariantId, directSubscribedForVariant);
    recordSubscriptionOverride(productGid, null, directSubscribedForFallback);
    refreshSubscribedKeysFromState(subscriptionStateByKey);
  }

  function replaceSubscriptionsSnapshot(data, options = {}) {
    hydrationCoverage = null;
    statusBootstrapSources.clear();
    statusBootstrapProductGids.clear();
    fillSubscriptionCache(data, options);
    controllers.forEach((controller) => controller.refresh());
    return subscriptionStateByKey;
  }

  function isProductHydrated(productGid) {
    if (!subscribedKeys || !productGid) return false;
    if (hydrationCoverage === null) return true;
    return hydrationCoverage instanceof Set && hydrationCoverage.has(productGid);
  }

  function areProductsHydrated(productGids) {
    if (!subscribedKeys) return false;
    if (hydrationCoverage === null) return true;
    return (
      hydrationCoverage instanceof Set &&
      productGids.length > 0 &&
      productGids.every((productGid) => hydrationCoverage.has(productGid))
    );
  }

  function ingestStatusBootstrap(data) {
    if (hydrationCoverage === null && subscribedKeys) {
      return subscribedKeys;
    }

    const productGids = Array.isArray(data?.productGids)
      ? Array.from(
          new Set(
            data.productGids.filter(
              (productGid) => typeof productGid === 'string' && productGid.trim(),
            ),
          ),
        )
      : [];
    const entries = extractGroups(data);
    if (!productGids.length || !Array.isArray(entries)) {
      return subscribedKeys;
    }

    const replacedProductGids = new Set(productGids);
    statusBootstrapSources.forEach((source, fingerprint) => {
      if (replacedProductGids.has(source.productGid)) {
        statusBootstrapSources.delete(fingerprint);
      }
    });

    entries.forEach((entry) => {
      const source = createSourceRecord(entry);
      if (!source || !replacedProductGids.has(source.productGid)) return;
      statusBootstrapSources.set(createSourceFingerprint(source), source);
    });
    productGids.forEach((productGid) => statusBootstrapProductGids.add(productGid));
    hydrationCoverage = new Set(statusBootstrapProductGids);
    fillSubscriptionCache({
      subscriptions: Array.from(statusBootstrapSources.values()),
    });

    controllers.forEach((controller) => {
      if (isProductHydrated(controller.getProductGid())) {
        controller.applyHydratedState(controller.getSubscriptionState());
      }
    });
    return subscribedKeys;
  }

  function emitSubscriptionChange(detail) {
    if (typeof document === 'undefined' || typeof document.dispatchEvent !== 'function') {
      return;
    }

    document.dispatchEvent(
      new CustomEvent(SUBSCRIPTION_CHANGE_EVENT, {
        detail: {
          type: 'product',
          productGid: detail?.productGid || '',
          variantId: detail?.variantId || null,
          subscribed: Boolean(detail?.subscribed),
          subscriptionState:
            detail?.productGid
              ? getProductSubscriptionState(detail.productGid, detail?.variantId || null)
              : null,
          payload: detail?.payload || null,
          source: detail?.source || 'restock-toggle-service',
        },
      }),
    );
  }

  function syncControllersForProduct(productGid, options = {}) {
    if (!productGid) return;

    const hasScopedVariant = Object.prototype.hasOwnProperty.call(options, 'variantId');
    const scopedVariantId = hasScopedVariant
      ? normalizeVariantId(options.variantId)
      : undefined;
    const fallbackScope = hasScopedVariant && scopedVariantId === null;
    const syncOptions =
      fallbackScope && Object.prototype.hasOwnProperty.call(options, 'subscriptionState')
        ? { ...options, subscriptionState: undefined }
        : options;

    controllers.forEach((controller) => {
      if (controller.getProductGid() !== productGid) return;
      if (
        hasScopedVariant &&
        !fallbackScope &&
        buildSubscriptionKey(productGid, controller.getVariantId()) !==
          buildSubscriptionKey(productGid, scopedVariantId)
      ) {
        return;
      }
      controller.syncFromCache(syncOptions);
    });

    if (
      sourcePopoverState.controller?.getProductGid?.() === productGid &&
      (!hasScopedVariant ||
        fallbackScope ||
        buildSubscriptionKey(productGid, sourcePopoverState.controller?.getVariantId?.()) ===
          buildSubscriptionKey(productGid, scopedVariantId))
    ) {
      refreshSourcePopoverForProduct(productGid);
    }
  }

  function syncAllControllersForProduct(productGid, options = {}) {
    if (!productGid) return;
    const nextOptions = { ...options };
    delete nextOptions.variantId;
    delete nextOptions.subscriptionState;
    syncControllersForProduct(productGid, nextOptions);
  }

  function scheduleHydration(apiBase) {
    const controllerProductGids = Array.from(
      new Set(
        Array.from(controllers)
          .map((controller) => controller.getProductGid())
          .filter(Boolean),
      ),
    );
    if (
      areProductsHydrated(controllerProductGids) ||
      hydrationPromise ||
      hydrationScheduled
    ) return;

    hydrationScheduled = true;
    hydrationApiBase = hydrationApiBase || normalizeApiBase(apiBase);

    const run = () => {
      hydrationScheduled = false;
      const productGids = Array.from(
        new Set(
          Array.from(controllers)
            .map((controller) => controller.getProductGid())
            .filter(Boolean),
        ),
      );
      ensureHydrated(hydrationApiBase, { productGids }).then(() => {
        controllers.forEach((controller) => {
          controller.applyHydratedState(controller.getSubscriptionState());
        });
        void replayPending();
      });
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 180);
    }
  }

  function ensureHydrated(apiBase, options = {}) {
    const productGids = Array.isArray(options.productGids)
      ? options.productGids.filter(Boolean)
      : [];
    if (areProductsHydrated(productGids)) {
      return Promise.resolve(subscribedKeys);
    }

    if (hydrationPromise) {
      return hydrationPromise;
    }

    const base = normalizeApiBase(apiBase);
    const previousState = subscriptionStateByKey;
    const previousKeys = subscribedKeys;
    const previousCoverage = hydrationCoverage;
    const productChunks = [];
    for (let index = 0; index < productGids.length; index += 50) {
      productChunks.push(productGids.slice(index, index + 50));
    }
    hydrationPromise = Promise.all(productChunks.map((chunk) => {
      const params = new URLSearchParams({ active: '1' });
      chunk.forEach((productGid) => params.append('productGid', productGid));
      return fetch(`${base}/v1/subscriptions?${params.toString()}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error(String(response.status || 'Failed to hydrate restock subscriptions'));
        return response.json();
      });
    }))
      .then((payloads) => {
        payloads.forEach(ingestStatusBootstrap);
        return subscribedKeys;
      })
      .catch(() => {
        if (previousKeys) {
          subscriptionStateByKey = previousState;
          subscribedKeys = previousKeys;
          hydrationCoverage = previousCoverage;
        } else {
          subscriptionStateByKey = new Map();
          subscribedKeys = new Set();
          hydrationCoverage = new Set();
        }
        return subscribedKeys;
      })
      .finally(() => {
        hydrationPromise = null;
      });

    return hydrationPromise;
  }

  async function replayPending() {
    const optimistic = window.MrMapleOptimistic;
    if (!optimistic || typeof optimistic.listPersistedToggleIntents !== 'function') {
      return [];
    }

    const entries = optimistic.listPersistedToggleIntents(RESTOCK_OPTIMISTIC_PREFIX);
    if (!entries.length) {
      return [];
    }

    const base = normalizeApiBase(hydrationApiBase || '/apps/garden');
    const STALE_INTENT_MS = 60000;
    const now = Date.now();

    return Promise.allSettled(entries.map(async (entry) => {
      const parsed = parseOptimisticPersistenceKey(entry.key);
      if (!parsed?.productGid) {
        optimistic.clearPersistedToggleIntent?.(entry.key);
        return;
      }

      if (
        typeof entry.updatedAt === 'number' &&
        entry.updatedAt > 0 &&
        now - entry.updatedAt > STALE_INTENT_MS
      ) {
        optimistic.clearPersistedToggleIntent?.(entry.key);
        return;
      }

      await requestProductSubscription({
        apiBase: base,
        productGid: parsed.productGid,
        variantId: parsed.variantId,
        subscribed: Boolean(entry.value),
        source: 'restock-toggle-replay',
        requestSource: 'restock-toggle-replay',
      });
      optimistic.clearPersistedToggleIntent?.(entry.key);
    }));
  }

  function flushPending(options = {}) {
    const optimistic = window.MrMapleOptimistic;
    const tasks = [];

    mutationStateByKey.forEach((record) => {
      if (record?.syncPromise) {
        tasks.push(Promise.resolve(record.syncPromise));
      }
      if (record?.sourceActionPromise) {
        tasks.push(Promise.resolve(record.sourceActionPromise));
      }
    });

    if (optimistic && typeof optimistic.flushAllPending === 'function') {
      tasks.push(
        Promise.resolve(
          optimistic.flushAllPending({
            reason: options.reason || 'restock-flush',
            keepalive: options.keepalive === true,
          }),
        ),
      );
    }

    return Promise.allSettled(tasks);
  }

  function createToggleError(message, options = {}) {
    const error = new Error(message);
    error.status = options.status || 0;
    error.payload = options.payload || null;
    error.unauthorized = Boolean(options.unauthorized);
    error.rateLimited = Boolean(options.rateLimited);
    return error;
  }

  function hasKnownCustomerSession() {
    return Boolean(
      String(window.MrMapleCustomer?.id || '').trim() ||
        String(window.ShopifyCustomer?.id || window.Shopify?.customer?.id || '').trim() ||
        String(document.querySelector('[data-customer-id]')?.getAttribute('data-customer-id') || '').trim(),
    );
  }

  function isExplicitAnonymousCustomerSession() {
    return window.MrMapleCustomer?.isAuthenticated === false && !hasKnownCustomerSession();
  }

  function createUnauthorizedCustomerError() {
    return createToggleError('Please sign in to manage restock alerts.', {
      status: 401,
      unauthorized: true,
    });
  }

  function isExpectedToggleError(error) {
    const status = Number(error?.status || 0);
    return Boolean(error?.unauthorized || error?.rateLimited || status === 401 || status === 403 || status === 429);
  }

  function shouldReportUnhandledToggleError(error) {
    return !isExpectedToggleError(error);
  }

  async function parseJsonSafe(response) {
    try {
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch (_) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function sourceBadgeLabel(source) {
    if (!source) return 'Alert';
    if (source.sourceType === 'direct') return 'Direct';
    return source.wishlistName || 'List';
  }

  function sourceOriginText(source) {
    if (!source) return 'this alert';
    if (source.sourceType === 'direct') return 'this product page';
    return source.wishlistName || 'a saved list';
  }

  function sourceSummaryText(state) {
    if (!state?.aggregateSubscribed) {
      return 'Notify me when this plant is back in stock';
    }

    if (state.sources.length === 1) {
      return `Alert set from ${sourceOriginText(state.sources[0])}`;
    }

    const first = sourceOriginText(state.sources[0]);
    const remainder = state.sources.length - 1;
    return `Alerts active from ${first} and ${remainder} other source${remainder === 1 ? '' : 's'}`;
  }

  function detailedSourceSummaryText(state) {
    if (!state?.aggregateSubscribed) return '';
    const labels = state.sources.map((source) => sourceOriginText(source));
    if (labels.length <= 2) {
      return labels.join(' and ');
    }
    return `${labels.slice(0, 2).join(', ')} and ${labels.length - 2} more`;
  }

  function ensureSourcePopoverStyles() {
    if (sourcePopoverStyleMounted || typeof document === 'undefined') return;

    const style = document.createElement('style');
    style.id = 'mm-restock-source-popover-style';
    style.textContent = `
      .mm-restock-source-popover {
        position: fixed;
        z-index: 9999;
        width: min(360px, calc(100vw - 24px));
        border-radius: 18px;
        border: 1px solid rgba(36, 49, 29, 0.12);
        background: rgba(255, 255, 255, 0.98);
        box-shadow: 0 22px 48px rgba(15, 23, 42, 0.16);
        backdrop-filter: blur(12px);
        color: #24311d;
        padding: 16px;
      }
      .mm-restock-source-popover[hidden] {
        display: none;
      }
      .mm-restock-source-popover__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 12px;
      }
      .mm-restock-source-popover__eyebrow {
        margin: 0 0 4px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: rgba(36, 49, 29, 0.62);
      }
      .mm-restock-source-popover__title {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.35;
      }
      .mm-restock-source-popover__close {
        border: 0;
        background: transparent;
        color: rgba(36, 49, 29, 0.72);
        cursor: pointer;
        padding: 4px;
        font-size: 18px;
        line-height: 1;
      }
      .mm-restock-source-popover__list {
        display: grid;
        gap: 10px;
        margin: 0;
        padding: 0;
        list-style: none;
      }
      .mm-restock-source-popover__item {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 12px;
        align-items: center;
        border: 1px solid rgba(36, 49, 29, 0.08);
        border-radius: 14px;
        padding: 12px;
        background: rgba(247, 245, 240, 0.88);
      }
      .mm-restock-source-popover__source {
        display: grid;
        gap: 4px;
        min-width: 0;
      }
      .mm-restock-source-popover__badge {
        display: inline-flex;
        width: fit-content;
        border-radius: 999px;
        background: rgba(47, 134, 52, 0.12);
        color: #236628;
        padding: 4px 10px;
        font-size: 12px;
        font-weight: 700;
      }
      .mm-restock-source-popover__description {
        font-size: 13px;
        color: rgba(36, 49, 29, 0.72);
        line-height: 1.4;
      }
      .mm-restock-source-popover__action,
      .mm-restock-source-popover__remove-all {
        border: 0;
        border-radius: 999px;
        background: #24311d;
        color: #fff;
        cursor: pointer;
        font: inherit;
        font-size: 13px;
        font-weight: 700;
        padding: 10px 14px;
      }
      .mm-restock-source-popover__action[disabled],
      .mm-restock-source-popover__remove-all[disabled] {
        opacity: 0.56;
        cursor: wait;
      }
      .mm-restock-source-popover__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-top: 14px;
      }
      .mm-restock-source-popover__manage {
        color: #236628;
        font-size: 13px;
        font-weight: 700;
        text-decoration: underline;
      }
    `;

    document.head.appendChild(style);
    sourcePopoverStyleMounted = true;
  }

  function closeSourcePopover() {
    if (typeof sourcePopoverState.cleanup === 'function') {
      sourcePopoverState.cleanup();
    }

    if (sourcePopoverState.root?.parentNode) {
      sourcePopoverState.root.parentNode.removeChild(sourcePopoverState.root);
    }

    sourcePopoverState.root = null;
    sourcePopoverState.anchor = null;
    sourcePopoverState.controller = null;
    sourcePopoverState.cleanup = null;
  }

  function positionSourcePopover(anchor, root) {
    if (!(anchor instanceof Element) || !(root instanceof HTMLElement)) return;

    const rect = anchor.getBoundingClientRect();
    const width = root.offsetWidth || 320;
    const maxLeft = Math.max(12, window.innerWidth - width - 12);
    const left = Math.min(Math.max(12, rect.right - width), maxLeft);
    const desiredTop = rect.bottom + 12;
    const maxTop = Math.max(12, window.innerHeight - root.offsetHeight - 12);
    root.style.left = `${left}px`;
    root.style.top = `${Math.min(desiredTop, maxTop)}px`;
  }

  function refreshSourcePopoverForProduct(productGid) {
    if (
      !productGid ||
      !sourcePopoverState.root ||
      !sourcePopoverState.anchor ||
      !sourcePopoverState.controller ||
      sourcePopoverState.controller.getProductGid() !== productGid
    ) {
      return;
    }

    const state = sourcePopoverState.controller.getSubscriptionState();
    if (!state.aggregateSubscribed || state.sources.length === 0) {
      closeSourcePopover();
      return;
    }

    openSourcePopover(sourcePopoverState.controller, sourcePopoverState.anchor);
  }

  function openSourcePopover(controller, anchor) {
    if (!(anchor instanceof Element) || !controller) return;

    const state = controller.getSubscriptionState();
    if (!state.aggregateSubscribed || state.sources.length === 0) return;

    ensureSourcePopoverStyles();
    closeSourcePopover();

    const root = document.createElement('div');
    root.className = 'mm-restock-source-popover';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'Manage restock alerts');
    root.innerHTML = `
      <div class="mm-restock-source-popover__header">
        <div>
          <p class="mm-restock-source-popover__eyebrow">Restock Alerts</p>
          <p class="mm-restock-source-popover__title">You&apos;re getting notified from ${escapeHtml(detailedSourceSummaryText(state))}.</p>
        </div>
        <button type="button" class="mm-restock-source-popover__close" data-action="close" aria-label="Close alert sources">×</button>
      </div>
      <ul class="mm-restock-source-popover__list">
        ${state.sources
          .map((source) => {
            const fingerprint = createSourceFingerprint(source);
            return `
              <li class="mm-restock-source-popover__item">
                <div class="mm-restock-source-popover__source">
                  <span class="mm-restock-source-popover__badge">${escapeHtml(sourceBadgeLabel(source))}</span>
                  <span class="mm-restock-source-popover__description">Alert active from ${escapeHtml(sourceOriginText(source))}</span>
                </div>
                <button
                  type="button"
                  class="mm-restock-source-popover__action"
                  data-action="remove-source"
                  data-source-fingerprint="${escapeHtml(fingerprint)}"
                  ${controller.isSourceActionPending() ? 'disabled' : ''}
                >
                  Turn off
                </button>
              </li>
            `;
          })
          .join('')}
      </ul>
      <div class="mm-restock-source-popover__footer">
        <button
          type="button"
          class="mm-restock-source-popover__remove-all"
          data-action="remove-all"
          ${controller.isSourceActionPending() ? 'disabled' : ''}
        >
          Turn off all
        </button>
        <a class="mm-restock-source-popover__manage" href="/account#notifications">Manage alerts</a>
      </div>
    `;

    const onDocumentPointerDown = (event) => {
      if (!(event.target instanceof Node)) return;
      if (root.contains(event.target) || anchor.contains(event.target)) return;
      closeSourcePopover();
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeSourcePopover();
      }
    };

    const onReposition = () => {
      positionSourcePopover(anchor, root);
    };

    root.addEventListener('click', (event) => {
      const actionEl = event.target?.closest?.('[data-action]');
      if (!actionEl) return;

      const action = actionEl.getAttribute('data-action');
      if (action === 'close') {
        closeSourcePopover();
        return;
      }

      if (action === 'remove-all') {
        // State restoration and user feedback happen inside the controller.
        // Consume the DOM event's Promise so a handled network failure does not
        // become a global unhandled-rejection Sentry issue.
        controller.removeAllSources().catch(() => {});
        return;
      }

      if (action === 'remove-source') {
        const fingerprint = actionEl.getAttribute('data-source-fingerprint');
        if (fingerprint) {
          controller.removeSourceByFingerprint(fingerprint).catch(() => {});
        }
      }
    });

    document.body.appendChild(root);
    positionSourcePopover(anchor, root);
    document.addEventListener('mousedown', onDocumentPointerDown, true);
    document.addEventListener('touchstart', onDocumentPointerDown, true);
    document.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onReposition);
    window.addEventListener('scroll', onReposition, true);

    sourcePopoverState.root = root;
    sourcePopoverState.anchor = anchor;
    sourcePopoverState.controller = controller;
    sourcePopoverState.cleanup = () => {
      document.removeEventListener('mousedown', onDocumentPointerDown, true);
      document.removeEventListener('touchstart', onDocumentPointerDown, true);
      document.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', onReposition);
      window.removeEventListener('scroll', onReposition, true);
    };
  }

  async function requestProductSubscription(options = {}) {
    const apiBase = normalizeApiBase(options.apiBase);
    const productGid = resolveValue(options.productGid, null);
    const variantId = normalizeVariantId(resolveValue(options.variantId, null));
    const customerEmail = resolveValue(options.customerEmail, null);
    const subscribed = Boolean(resolveValue(options.subscribed, null));
    const trace = createClientTraceContext(options);

    if (!productGid) {
      throw createToggleError('Unable to identify this product.');
    }

    if (isExplicitAnonymousCustomerSession()) {
      throw createUnauthorizedCustomerError();
    }

    logClientTrace(trace, 'request:start', {
      method: subscribed ? 'POST' : 'DELETE',
      apiBase,
      productGid,
      variantId,
      hasCustomerEmail: Boolean(customerEmail),
    });
    //console.log(`[RestockToggle:DEBUG] ${subscribed ? 'POST' : 'DELETE'} ${apiBase}/v1/notifications/toggle — productGid=${productGid}, variantId=${variantId}, email=${customerEmail || 'none'}`);
    const response = await fetch(`${apiBase}/v1/notifications/toggle`, {
      method: subscribed ? 'POST' : 'DELETE',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        [RESTOCK_TRACE_ID_HEADER]: trace.traceId,
        [RESTOCK_TRACE_SOURCE_HEADER]: trace.source,
        ...(trace.surface ? { [RESTOCK_TRACE_SURFACE_HEADER]: trace.surface } : {}),
        ...(trace.component ? { [RESTOCK_TRACE_COMPONENT_HEADER]: trace.component } : {}),
      },
      body: JSON.stringify({
        type: 'product',
        productGid,
        variantId,
        ...(customerEmail ? { customerEmail } : {}),
      }),
    });

    const payload = await parseJsonSafe(response);
    const responseTraceId = response.headers.get(RESTOCK_TRACE_ID_HEADER) || trace.traceId;
    logClientTrace({ ...trace, traceId: responseTraceId }, 'response:received', {
      status: response.status,
      ok: response.ok,
      payload,
    });
    //console.log(`[RestockToggle:DEBUG] Response — status=${response.status}, ok=${response.ok}, payload=`, payload);

    if (!response.ok) {
      logClientTrace({ ...trace, traceId: responseTraceId }, 'response:error', {
        status: response.status,
        error: payload?.error || null,
      });
      //console.error(`[RestockToggle:DEBUG] FAILED — status=${response.status}, error=${payload?.error}`);
      throw createToggleError(
        payload?.error || 'Unable to save your alert. Please try again.',
        {
          status: response.status,
          payload,
          unauthorized: response.status === 401 || response.status === 403,
          rateLimited: response.status === 429,
        },
      );
    }

    setCachedDirectSubscription(productGid, variantId, subscribed, payload);
    emitSubscriptionChange({
      productGid,
      variantId,
      subscribed: getProductSubscriptionState(productGid, variantId).aggregateSubscribed,
      payload,
      source: options.source,
    });

    return {
      response,
      payload,
      productGid,
      variantId,
      subscribed,
      traceId: responseTraceId,
    };
  }

  async function requestSourceRemoval(options = {}) {
    const apiBase = normalizeApiBase(options.apiBase);
    const productGid = resolveValue(options.productGid, null);
    const variantId = normalizeVariantId(resolveValue(options.variantId, null));
    const customerEmail = resolveValue(options.customerEmail, null);
    const source = cloneSource(resolveValue(options.source, null));
    const sourceVariantId = getSourceVariantId(source);
    const requestSubscriptionId = isPersistedSubscriptionId(source?.subscriptionId)
      ? source.subscriptionId.trim()
      : null;
    const trace = createClientTraceContext(options);

    if (!productGid || !source?.productGid) {
      throw createToggleError('Unable to identify this alert source.');
    }

    if (isExplicitAnonymousCustomerSession()) {
      throw createUnauthorizedCustomerError();
    }

    logClientTrace(trace, 'source-removal:start', {
      apiBase,
      productGid,
      variantId,
      sourceType: source.sourceType,
      subscriptionId: requestSubscriptionId,
      wishlistId: source.wishlistId,
    });
    const response = await fetch(`${apiBase}/v1/notifications/toggle`, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        [RESTOCK_TRACE_ID_HEADER]: trace.traceId,
        [RESTOCK_TRACE_SOURCE_HEADER]: trace.source,
        ...(trace.surface ? { [RESTOCK_TRACE_SURFACE_HEADER]: trace.surface } : {}),
        ...(trace.component ? { [RESTOCK_TRACE_COMPONENT_HEADER]: trace.component } : {}),
      },
      body: JSON.stringify({
        type: 'product',
        productGid,
        variantId: sourceVariantId,
        ...(source.wishlistId ? { wishlistId: source.wishlistId } : {}),
        ...(requestSubscriptionId ? { subscriptionId: requestSubscriptionId } : {}),
        ...(customerEmail ? { customerEmail } : {}),
      }),
    });

    const payload = await parseJsonSafe(response);
    const responseTraceId = response.headers.get(RESTOCK_TRACE_ID_HEADER) || trace.traceId;
    logClientTrace({ ...trace, traceId: responseTraceId }, 'source-removal:response', {
      status: response.status,
      ok: response.ok,
      payload,
    });

    if (!response.ok) {
      throw createToggleError(
        payload?.error || 'Unable to update your alert. Please try again.',
        {
          status: response.status,
          payload,
          unauthorized: response.status === 401 || response.status === 403,
          rateLimited: response.status === 429,
        },
      );
    }

    if (source.sourceType === 'direct') {
      setCachedDirectSubscription(productGid, sourceVariantId, false);
    } else {
      removeCachedSource(productGid, sourceVariantId, (existing) => {
        return createSourceFingerprint(existing) === createSourceFingerprint(source);
      });
    }

    emitSubscriptionChange({
      productGid,
      variantId,
      subscribed: getProductSubscriptionState(productGid, variantId).aggregateSubscribed,
      payload,
      source: options.requestSource || 'source-removal',
    });

    return { response, payload, productGid, variantId, source };
  }

  async function requestRemoveAllProductSources(options = {}) {
    const productGid = resolveValue(options.productGid, null);
    const variantId = normalizeVariantId(resolveValue(options.variantId, null));
    const sources = Array.isArray(options.sources) ? options.sources.map(cloneSource) : [];

    if (!productGid || sources.length === 0) {
      return [];
    }

    const results = [];
    for (const source of sources) {
      const result = await requestSourceRemoval({
        ...options,
        source,
        productGid,
        variantId,
      });
      results.push(result);
    }

    return results;
  }

  function resolveBellTarget(root, subscribed) {
    if (!root || typeof root.querySelector !== 'function') {
      return root || null;
    }

    return (
      (subscribed
        ? root.querySelector('.restock-bell--filled')
        : root.querySelector('.restock-bell--outline')) ||
      root.querySelector('.restock-bell, .bell-icon, .atc-button--icon, .collection-product-action-icon--bell') ||
      root
    );
  }

  function prefersReducedMotion() {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
  }

  function ring(target) {
    if (!target || prefersReducedMotion()) return;

    target.classList.remove(RINGING_CLASS);
    void target.offsetHeight;
    target.classList.add(RINGING_CLASS);
    target.addEventListener(
      'animationend',
      () => {
        target.classList.remove(RINGING_CLASS);
      },
      { once: true },
    );
  }

  function showThemeToast(message, type = 'info', options = {}) {
    const toastEl = document.querySelector('.wl-toast');
    if (!toastEl) return;

    const messageEl = toastEl.querySelector('.wl-toast-message');
    if (!messageEl) return;

    let link = null;
    messageEl.textContent = '';
    messageEl.appendChild(document.createTextNode(message));

    if (options.linkText && options.linkHref) {
      link = document.createElement('a');
      link.href = options.linkHref;
      link.textContent = options.linkText;
      link.style.cssText = 'color: inherit; text-decoration: underline; font-weight: 500;';
      messageEl.appendChild(document.createTextNode(' '));
      messageEl.appendChild(link);
    }

    toastEl.classList.remove('wl-toast--success', 'wl-toast--error', 'wl-toast--info');
    toastEl.classList.add(`wl-toast--${type}`);
    toastEl.removeAttribute('hidden');
    toastEl.setAttribute('aria-hidden', 'false');
    void toastEl.offsetHeight;

    if (toastState.timer) {
      clearTimeout(toastState.timer);
    }

    const dismiss = () => {
      toastEl.setAttribute('aria-hidden', 'true');
      toastEl.setAttribute('hidden', 'true');
      if (toastState.timer) {
        clearTimeout(toastState.timer);
        toastState.timer = null;
      }
    };

    if (link) {
      link.addEventListener('click', dismiss, { once: true });
    }

    const closeBtn = toastEl.querySelector('.wl-toast-close');
    if (closeBtn?.parentNode) {
      const fresh = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(fresh, closeBtn);
      fresh.addEventListener('click', dismiss);
    }

    toastState.timer = window.setTimeout(dismiss, options.linkHref ? 5000 : 3500);
  }

  function scheduleRestockToast(key, message, type = 'info', options = {}) {
    if (!key) {
      showThemeToast(message, type, options);
      return;
    }

    const normalizedKey = String(key);
    const now = Date.now();
    const existing = scheduledToastState.get(normalizedKey) || null;

    if (existing?.timer) {
      window.clearTimeout(existing.timer);
    }

    const lastShownAt = Number(existing?.shownAt) || 0;
    const isRapid = lastShownAt > 0 && now - lastShownAt < SCHEDULED_TOAST_RAPID_WINDOW_MS;

    if (!isRapid) {
      showThemeToast(message, type, options);
      scheduledToastState.set(normalizedKey, {
        shownAt: now,
        timer: null,
        latestMessage: message,
        latestType: type,
        latestOptions: options,
      });
      return;
    }

    const timer = window.setTimeout(() => {
      const entry = scheduledToastState.get(normalizedKey);
      if (!entry) return;
      showThemeToast(entry.latestMessage, entry.latestType, entry.latestOptions);
      scheduledToastState.set(normalizedKey, {
        shownAt: Date.now(),
        timer: null,
        latestMessage: entry.latestMessage,
        latestType: entry.latestType,
        latestOptions: entry.latestOptions,
      });
    }, SCHEDULED_TOAST_DEBOUNCE_MS);

    scheduledToastState.set(normalizedKey, {
      shownAt: lastShownAt,
      timer,
      latestMessage: message,
      latestType: type,
      latestOptions: options,
    });
  }

  function applyButtonSubscribedState(button, subscribed, options = {}) {
    if (!button) return;

    const labelSelector = options.labelSelector || '[data-mm-restock-label], .restock-label';
    const labelEl =
      typeof options.getLabelElement === 'function'
        ? options.getLabelElement(button)
        : button.querySelector(labelSelector);

    if (labelEl && !button.dataset.mmRestockDefaultLabel) {
      button.dataset.mmRestockDefaultLabel =
        labelEl.textContent?.trim() ||
        button.getAttribute('aria-label') ||
        'Notify me';
    }

    const defaultLabel =
      options.defaultLabel ||
      button.dataset.mmRestockDefaultLabel ||
      button.dataset.defaultText ||
      button.getAttribute('data-default-text') ||
      'Notify me';

    const subscribedLabel =
      options.subscribedLabel ||
      button.dataset.mmRestockSubscribedLabel ||
      button.dataset.subscribedText ||
      button.getAttribute('data-subscribed-text') ||
      button.dataset.alreadyText ||
      button.getAttribute('data-already-text') ||
      "We'll email you when restocked";

    const subscriptionState =
      options.subscriptionState && typeof options.subscriptionState === 'object'
        ? options.subscriptionState
        : null;
    const subscribedSummary = subscriptionState?.aggregateSubscribed
      ? sourceSummaryText(subscriptionState)
      : 'Restock alert set';
    const subscribedDescription = subscriptionState?.aggregateSubscribed
      ? detailedSourceSummaryText(subscriptionState)
      : '';
    const hasMultipleSources = Number(subscriptionState?.sources?.length || 0) > 1;

    if (subscribed) {
      button.classList.add(SUBSCRIBED_CLASS);
      button.dataset.restockSubscribed = 'true';
      button.setAttribute('aria-pressed', 'true');
      button.dataset.mmRestockSourceSummary = subscribedDescription;
      button.dataset.mmRestockSourceCount = String(
        Number(subscriptionState?.sources?.length || 0),
      );
      button.setAttribute(
        'aria-label',
        options.subscribedAriaLabel ||
          `${subscribedSummary}. Click to ${hasMultipleSources ? 'manage alert sources' : 'turn off this alert'}.`,
      );
      button.setAttribute('title', options.subscribedTitle || subscribedSummary);
      if (labelEl) {
        labelEl.textContent = subscribedLabel;
      }
    } else {
      button.classList.remove(SUBSCRIBED_CLASS);
      button.dataset.restockSubscribed = 'false';
      delete button.dataset.mmRestockSourceSummary;
      delete button.dataset.mmRestockSourceCount;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute(
        'aria-label',
        options.defaultAriaLabel || defaultLabel,
      );
      button.setAttribute('title', options.defaultTitle || defaultLabel);
      if (labelEl) {
        labelEl.textContent = defaultLabel;
      }
    }

    button.disabled = false;
  }

  class RestockProductToggleController {
    constructor(options = {}) {
      this.options = options;
      this.pendingVisibleUntil = 0;
      this.pendingRenderTimer = null;
      this.pendingRenderSnapshot = null;
      this.initialSubscribedHint = Boolean(resolveValue(options.initialSubscribed, this));

      controllers.add(this);
      if (this.initialSubscribedHint) {
        writePersistedSubscriptionHint(this.getProductGid(), this.getVariantId(), true);
      }

      this.getMutationState(this.initialSubscribedHint);
      this.syncFromCache({
        commit: true,
        hydrated: Boolean(subscribedKeys),
        pending: false,
      });

      const apiBase = this.getApiBase();
      if (isProductHydrated(this.getProductGid())) {
        this.applyHydratedState(this.getSubscriptionState());
      } else {
        scheduleHydration(apiBase);
        if (hydrationPromise) {
          hydrationPromise.then(() => {
            this.applyHydratedState(this.getSubscriptionState());
          });
        }
      }
    }

    getApiBase() {
      return normalizeApiBase(resolveValue(this.options.apiBase, this));
    }

    getProductGid() {
      return resolveValue(this.options.productGid, this);
    }

    getVariantId() {
      return normalizeVariantId(resolveValue(this.options.variantId, this));
    }

    getCustomerEmail() {
      const value = resolveValue(this.options.customerEmail, this);
      return typeof value === 'string' ? value.trim() : '';
    }

    getMutationState(initialDirectSubscribed = false) {
      return getProductMutationState(
        this.getProductGid(),
        this.getVariantId(),
        initialDirectSubscribed,
      );
    }

    getSubscriptionState() {
      return getProductSubscriptionState(this.getProductGid(), this.getVariantId());
    }

    guardCustomerSession() {
      if (!isExplicitAnonymousCustomerSession()) {
        return true;
      }

      const error = createUnauthorizedCustomerError();
      if (typeof this.options.onUnauthorized === 'function') {
        this.options.onUnauthorized(error, this);
      } else if (typeof this.options.onError === 'function') {
        this.options.onError(error, this);
      }
      return false;
    }

    getSourcePopoverAnchor(event) {
      const explicitAnchor = resolveValue(this.options.sourcePopoverAnchor, this);
      if (explicitAnchor instanceof Element) return explicitAnchor;
      if (event?.currentTarget instanceof Element) return event.currentTarget;
      if (document.activeElement instanceof Element) return document.activeElement;
      return null;
    }

    getSubscribedClickBehavior() {
      const behavior = resolveValue(this.options.subscribedClickBehavior, this);
      return behavior === 'remove-all-sources' ? 'remove-all-sources' : 'manage-sources';
    }

    isPending() {
      const record = this.getMutationState();
      return Boolean(record.syncPromise || record.sourceActionPromise);
    }

    isSourceActionPending() {
      return Boolean(this.getMutationState().sourceActionPromise);
    }

    render(subscriptionState, meta = {}) {
      if (typeof this.options.render !== 'function') {
        return;
      }

      const state =
        subscriptionState && typeof subscriptionState === 'object'
          ? subscriptionState
          : this.getSubscriptionState();
      const record = this.getMutationState();
      const renderMeta = {
        subscribed: Boolean(state.aggregateSubscribed),
        directSubscribed: Boolean(state.directSubscribed),
        hasIndirectSources: Boolean(state.hasIndirectSources),
        sources: Array.isArray(state.sources) ? state.sources.map(cloneSource) : [],
        labels: Array.isArray(state.labels) ? [...state.labels] : [],
        subscriptionState: state,
        pending:
          meta.pending !== undefined
            ? Boolean(meta.pending)
            : Boolean(record.syncPromise || record.sourceActionPromise),
        hydrated: Boolean(meta.hydrated),
        optimistic: Boolean(meta.optimistic),
        sourceActionPending: Boolean(record.sourceActionPromise),
        controller: this,
      };

      if (this.pendingRenderTimer) {
        window.clearTimeout(this.pendingRenderTimer);
        this.pendingRenderTimer = null;
      }

      if (renderMeta.pending) {
        this.pendingVisibleUntil = Date.now() + MIN_PENDING_MS;
        this.pendingRenderSnapshot = null;
        this.options.render(renderMeta);
        return;
      }

      const remaining = this.pendingVisibleUntil - Date.now();
      if (remaining > 0) {
        this.pendingRenderSnapshot = renderMeta;
        this.pendingRenderTimer = window.setTimeout(() => {
          this.pendingRenderTimer = null;
          const snapshot = this.pendingRenderSnapshot;
          this.pendingRenderSnapshot = null;
          if (snapshot) {
            this.options.render(snapshot);
          }
        }, remaining);
        return;
      }

      this.pendingRenderSnapshot = null;
      this.options.render(renderMeta);
    }

    syncFromCache(meta = {}) {
      const state =
        meta.subscriptionState && typeof meta.subscriptionState === 'object'
          ? meta.subscriptionState
          : this.getSubscriptionState();
      const record = this.getMutationState();

      if (meta.commit !== false) {
        record.committedDirectSubscribed = Boolean(state.directSubscribed);
        if (!record.syncPromise) {
          record.desiredDirectSubscribed = Boolean(state.directSubscribed);
        }
      }

      this.render(state, {
        hydrated: meta.hydrated !== false,
        pending:
          meta.pending !== undefined
            ? meta.pending
            : Boolean(record.syncPromise || record.sourceActionPromise),
        optimistic: Boolean(meta.optimistic),
      });
    }

    applyHydratedState(subscriptionState) {
      this.syncFromCache({
        subscriptionState,
        commit: true,
        hydrated: true,
      });
    }

    refresh() {
      this.syncFromCache({
        commit: !this.getMutationState().syncPromise,
        hydrated: true,
      });
    }

    emitOptimisticChange(previousState, nextState) {
      if (typeof this.options.onOptimisticChange !== 'function') {
        return;
      }

      const previousAggregate = Boolean(previousState?.aggregateSubscribed);
      const nextAggregate = Boolean(nextState?.aggregateSubscribed);
      const previousDirect = Boolean(previousState?.directSubscribed);
      const nextDirect = Boolean(nextState?.directSubscribed);

      if (
        previousAggregate === nextAggregate &&
        previousDirect === nextDirect
      ) {
        return;
      }

      this.options.onOptimisticChange(
        {
          subscribed: nextAggregate,
          previousSubscribed: previousAggregate,
          directSubscribed: nextDirect,
          previousDirectSubscribed: previousDirect,
          subscriptionState: nextState,
          pending: true,
        },
        this,
      );
    }

    setDesiredDirectState(directSubscribed) {
      const nextDirectSubscribed = Boolean(directSubscribed);
      const record = this.getMutationState();
      const previousState = this.getSubscriptionState();
      const previousDirectSubscribed = Boolean(record.desiredDirectSubscribed);
      record.desiredDirectSubscribed = nextDirectSubscribed;
      setCachedDirectSubscription(
        this.getProductGid(),
        this.getVariantId(),
        nextDirectSubscribed,
      );

      const nextState = this.getSubscriptionState();
      syncControllersForProduct(this.getProductGid(), {
        variantId: this.getVariantId(),
        subscriptionState: nextState,
        commit: false,
        hydrated: true,
        optimistic: true,
        pending: true,
      });

      if (previousDirectSubscribed !== nextDirectSubscribed) {
        this.emitOptimisticChange(previousState, nextState);
      }
    }

    shouldOpenSourcePopover(state) {
      if (this.getSubscribedClickBehavior() !== 'manage-sources') {
        return false;
      }

      return Boolean(
        state?.aggregateSubscribed && (state.hasIndirectSources || state.sources.length > 1),
      );
    }

    toggle(event) {
      if (!this.guardCustomerSession()) {
        return Promise.resolve({ unauthorized: true });
      }

      const state = this.getSubscriptionState();
      if (state.aggregateSubscribed && this.getSubscribedClickBehavior() === 'remove-all-sources') {
        const record = this.getMutationState();
        const pendingOptimisticDirectOnly =
          Boolean(record.syncPromise) &&
          !state.hasIndirectSources &&
          Array.isArray(state.sources) &&
          state.sources.length > 0 &&
          state.sources.every((source) => source?.sourceType === 'direct');

        if (pendingOptimisticDirectOnly) {
          this.setDesiredDirectState(false);
          return this.syncDesiredState();
        }

        return this.removeAllSources({
          optimistic: true,
          suppressPartialToast: true,
        });
      }

      if (this.shouldOpenSourcePopover(state)) {
        const anchor = this.getSourcePopoverAnchor(event);
        if (anchor) {
          openSourcePopover(this, anchor);
        }
        return Promise.resolve({ popover: true });
      }

      const nextDirectSubscribed = !state.aggregateSubscribed;
      this.setDesiredDirectState(nextDirectSubscribed);

      const ringTarget = resolveValue(this.options.ringTarget, {
        controller: this,
        subscribed: nextDirectSubscribed || state.aggregateSubscribed,
      });
      if (ringTarget) {
        ring(ringTarget);
      }

      return this.syncDesiredState();
    }

    syncDesiredState() {
      const record = this.getMutationState();
      if (record.syncPromise) {
        return record.syncPromise;
      }

      record.syncPromise = new Promise((resolve) => {
        window.setTimeout(resolve, DIRECT_TOGGLE_DEBOUNCE_MS);
      })
        .then(() => this.flushDesiredState(record))
        .catch((error) => {
          if (
            shouldReportUnhandledToggleError(error) &&
            typeof this.options.onUnhandledError === 'function'
          ) {
            this.options.onUnhandledError(error, this);
          }
        })
        .finally(() => {
          record.syncPromise = null;

          if (record.desiredDirectSubscribed !== record.committedDirectSubscribed) {
            this.syncDesiredState();
            return;
          }

          syncControllersForProduct(this.getProductGid(), {
            variantId: this.getVariantId(),
            commit: true,
            hydrated: true,
            pending: Boolean(record.sourceActionPromise),
          });
        });

      return record.syncPromise;
    }

    async flushDesiredState(record) {
      while (record.desiredDirectSubscribed !== record.committedDirectSubscribed) {
        const targetSubscribed = record.desiredDirectSubscribed;

        try {
          const result = await requestProductSubscription({
            apiBase: this.getApiBase(),
            productGid: this.getProductGid(),
            variantId: this.getVariantId(),
            customerEmail: this.getCustomerEmail(),
            subscribed: targetSubscribed,
            source: resolveValue(this.options.requestSource, this) || 'controller',
            traceSurface: resolveValue(this.options.traceSurface, this),
            traceComponent: resolveValue(this.options.traceComponent, this),
          });

          record.committedDirectSubscribed = targetSubscribed;

          if (record.desiredDirectSubscribed !== targetSubscribed) {
            continue;
          }

          syncControllersForProduct(this.getProductGid(), {
            variantId: this.getVariantId(),
            commit: true,
            hydrated: true,
            pending: true,
          });

          if (typeof this.options.onSuccess === 'function') {
            const state = this.getSubscriptionState();
            this.options.onSuccess(
              {
                subscribed: state.aggregateSubscribed,
                directSubscribed: state.directSubscribed,
                subscriptionState: state,
                payload: result.payload,
                response: result.response,
              },
              this,
            );
          }
        } catch (error) {
          if (record.desiredDirectSubscribed === targetSubscribed) {
            record.desiredDirectSubscribed = record.committedDirectSubscribed;
            setCachedDirectSubscription(
              this.getProductGid(),
              this.getVariantId(),
              record.committedDirectSubscribed,
            );
            syncControllersForProduct(this.getProductGid(), {
              variantId: this.getVariantId(),
              commit: false,
              hydrated: true,
              pending: false,
            });

            if (error?.unauthorized && typeof this.options.onUnauthorized === 'function') {
              this.options.onUnauthorized(error, this);
            } else if (typeof this.options.onError === 'function') {
              this.options.onError(error, this);
            }
          }

          throw error;
        }
      }
    }

    enqueueSourceAction(action) {
      const record = this.getMutationState();
      const previous = record.sourceActionPromise || Promise.resolve();
      const current = previous
        .catch(() => {})
        .then(action)
        .catch((error) => {
          if (
            shouldReportUnhandledToggleError(error) &&
            typeof this.options.onUnhandledError === 'function'
          ) {
            this.options.onUnhandledError(error, this);
          }
          if (isExpectedToggleError(error)) {
            return null;
          }
          throw error;
        })
        .finally(() => {
          if (record.sourceActionPromise === current) {
            record.sourceActionPromise = null;
          }
          syncAllControllersForProduct(this.getProductGid(), {
            commit: !record.syncPromise,
            hydrated: true,
            pending: Boolean(record.syncPromise),
          });
        });

      record.sourceActionPromise = current;
      syncControllersForProduct(this.getProductGid(), {
        variantId: this.getVariantId(),
        commit: false,
        hydrated: true,
        pending: true,
      });
      return current;
    }

    findSourceByFingerprint(fingerprint) {
      if (!fingerprint) return null;
      return (
        this.getSubscriptionState().sources.find(
          (source) => createSourceFingerprint(source) === fingerprint,
        ) || null
      );
    }

    async performSourceRemoval(source, options = {}) {
      const targetSource = cloneSource(source);
      const record = this.getMutationState();
      const productGid = this.getProductGid();
      const variantId = this.getVariantId();
      const targetVariantId = getSourceVariantId(targetSource);

      if (targetSource.sourceType === 'direct') {
        record.desiredDirectSubscribed = false;
        setCachedDirectSubscription(productGid, targetVariantId, false);
      } else {
        removeCachedSource(productGid, targetVariantId, (existing) => {
          return createSourceFingerprint(existing) === createSourceFingerprint(targetSource);
        });
      }

      syncControllersForProduct(productGid, {
        variantId: targetVariantId,
        commit: false,
        hydrated: true,
        optimistic: true,
        pending: true,
      });

      try {
        await requestSourceRemoval({
          apiBase: this.getApiBase(),
          productGid,
          variantId,
          customerEmail: this.getCustomerEmail(),
          source: targetSource,
          requestSource:
            resolveValue(this.options.requestSource, this) || 'controller-source-removal',
          traceSurface: resolveValue(this.options.traceSurface, this),
          traceComponent: resolveValue(this.options.traceComponent, this),
        });

        if (targetSource.sourceType === 'direct') {
          record.committedDirectSubscribed = false;
          record.desiredDirectSubscribed = false;
        }

        const nextState = this.getSubscriptionState();
        syncControllersForProduct(productGid, {
          variantId: targetVariantId,
          commit: true,
          hydrated: true,
          pending: Boolean(record.syncPromise || record.sourceActionPromise),
        });

        if (!options.suppressToast) {
          if (nextState.aggregateSubscribed) {
            showThemeToast(
              `${sourceBadgeLabel(targetSource)} alert removed. Alerts still active from ${detailedSourceSummaryText(nextState)}.`,
              'info',
              {
                linkText: 'Manage alerts',
                linkHref: '/account#notifications',
              },
            );
          } else {
            showThemeToast('Restock notification removed.', 'info');
          }
        }

        return nextState;
      } catch (error) {
        if (targetSource.sourceType === 'direct') {
          setCachedDirectSubscription(
            productGid,
            targetVariantId,
            true,
            { subscriptionId: targetSource.subscriptionId },
          );
          record.desiredDirectSubscribed = true;
          record.committedDirectSubscribed = true;
        } else {
          upsertSourceRecord(createSubscriptionStateCache(), targetSource);
          refreshSubscribedKeysFromState(subscriptionStateByKey);
        }

        syncControllersForProduct(productGid, {
          variantId: targetVariantId,
          commit: false,
          hydrated: true,
          pending: Boolean(record.syncPromise),
        });

        if (error?.unauthorized && typeof this.options.onUnauthorized === 'function') {
          this.options.onUnauthorized(error, this);
        } else if (typeof this.options.onError === 'function') {
          this.options.onError(error, this);
        }

        throw error;
      }
    }

    removeSourceByFingerprint(fingerprint) {
      const source = this.findSourceByFingerprint(fingerprint);
      if (!source) {
        return Promise.resolve(null);
      }
      return this.removeSource(source);
    }

    removeSource(source) {
      if (!this.guardCustomerSession()) {
        return Promise.resolve({ unauthorized: true });
      }

      return this.enqueueSourceAction(() => this.performSourceRemoval(source));
    }

    removeAllSources(options = {}) {
      if (!this.guardCustomerSession()) {
        return Promise.resolve({ unauthorized: true });
      }

      const sources = this.getSubscriptionState().sources.map(cloneSource);
      if (!sources.length) {
        closeSourcePopover();
        return Promise.resolve([]);
      }

      return this.enqueueSourceAction(async () => {
        const optimistic = options.optimistic === true;
        const suppressPartialToast = options.suppressPartialToast === true;
        const previousState = this.getSubscriptionState();
        const record = this.getMutationState();
        const productGid = this.getProductGid();
        const variantId = this.getVariantId();

        if (optimistic) {
          replaceCachedSourcesForProduct(productGid, variantId, []);
          record.desiredDirectSubscribed = false;
          record.committedDirectSubscribed = false;

          const nextState = this.getSubscriptionState();
          syncAllControllersForProduct(productGid, {
            subscriptionState: nextState,
            commit: false,
            hydrated: true,
            optimistic: true,
            pending: true,
          });
          this.emitOptimisticChange(previousState, nextState);
        }

        const failures = [];
        for (const source of sources) {
          try {
            if (optimistic) {
              await requestSourceRemoval({
                apiBase: this.getApiBase(),
                productGid: this.getProductGid(),
                variantId: this.getVariantId(),
                customerEmail: this.getCustomerEmail(),
                source,
                requestSource:
                  resolveValue(this.options.requestSource, this) || 'controller-remove-all',
                traceSurface: resolveValue(this.options.traceSurface, this),
                traceComponent: resolveValue(this.options.traceComponent, this),
              });
            } else {
              await this.performSourceRemoval(source, { suppressToast: true });
            }
          } catch (error) {
            failures.push(error);
          }
        }

        if (optimistic && failures.length > 0) {
          replaceCachedSourcesForProduct(productGid, variantId, sources);
          record.desiredDirectSubscribed = Boolean(previousState.directSubscribed);
          record.committedDirectSubscribed = Boolean(previousState.directSubscribed);

          syncAllControllersForProduct(productGid, {
            subscriptionState: this.getSubscriptionState(),
            commit: false,
            hydrated: true,
            pending: false,
          });
        }

        const nextState = this.getSubscriptionState();
        if (nextState.aggregateSubscribed) {
          if (!suppressPartialToast) {
            showThemeToast(
              `Some alerts are still active from ${detailedSourceSummaryText(nextState)}.`,
              'info',
              {
                linkText: 'Manage alerts',
                linkHref: '/account#notifications',
              },
            );
          }
        } else {
          showThemeToast('Restock notification removed.', 'info');
          closeSourcePopover();
        }

        if (failures.length > 0) {
          const error = failures[0];
          if (error?.unauthorized && typeof this.options.onUnauthorized === 'function') {
            this.options.onUnauthorized(error, this);
          } else if (typeof this.options.onError === 'function') {
            this.options.onError(error, this);
          }
          throw error;
        }

        return nextState;
      });
    }

    destroy() {
      if (this.pendingRenderTimer) {
        window.clearTimeout(this.pendingRenderTimer);
        this.pendingRenderTimer = null;
      }
      controllers.delete(this);
    }
  }

  window.MMRestockToggleService = {
    SUBSCRIBED_CLASS,
    RINGING_CLASS,
    SUBSCRIPTION_CHANGE_EVENT,
    applyButtonSubscribedState,
    buildSubscriptionKey,
    createProductToggleController(options) {
      return new RestockProductToggleController(options);
    },
    ensureHydrated,
    getProductSubscriptionState,
    getCachedSubscription,
    ingestStatusBootstrap,
    normalizeApiBase,
    normalizeVariantId,
    readPersistedSubscriptionHint,
    replaceSubscriptionsSnapshot,
    requestProductSubscription,
    requestRemoveAllProductSources,
    requestSourceRemoval,
    flushPending,
    replayPending,
    resolveBellTarget,
    ring,
    showThemeToast,
    scheduleRestockToast,
    syncControllersForProduct,
    writePersistedSubscriptionHint,
    closeSourcePopover,
  };

  const pendingStatusBootstraps = window.MMRestockStatusBootstrapQueue;
  if (Array.isArray(pendingStatusBootstraps)) {
    pendingStatusBootstraps.forEach(ingestStatusBootstrap);
    delete window.MMRestockStatusBootstrapQueue;
  }

  void replayPending();
})();
